import React,{ useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../components/Header';
import Listarhorario from '../components/Listar_horario';
import Horario from '../components/Horario_show';
import Nrcinfohorario from '../components/Nrc_info_horario';

function Mishorarios() {
	const [selectcursos, setSelectcursos] = useState([]);
	const [horario,setHorario] = useState('');
  return (
	<div>
		<Header/>
		<Container>			
			<Row>
				<Col className="horariofiltros" md={4}>
					<Listarhorario
						selectcursos = {selectcursos}
						setSelectcursos = {setSelectcursos}
						horario = {horario}
						setHorario = {setHorario}
					/>
				</Col>		
				<Col md={8}>
					<Horario
						selectcursos = {selectcursos}
						horario = {horario}									
					/>				
				</Col>
				<Col className="infoprint" md={3}>
					<Nrcinfohorario
						selectcursos = {selectcursos}								
					/>
				</Col>
			</Row>
		</Container>		
	</div>
  );
}

export default Mishorarios;